// Make sure jQuery and Slick are loaded first, then run this code


$(document).ready(function() {


    if (window.innerWidth <= 768) {

        setTimeout(function() {
            $('.Supplement_Ingredient .card-container').slick({
                dots: true,
                  arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                prevArrow: '<button class="slider-nav prev" id="slick-prev" type="button"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15,18 9,12 15,6"></polyline></svg></button>',
                nextArrow: '<button class="slider-nav next" id="slick-next" type="button"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9,18 15,12 9,6"></polyline></svg></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            $('.mob-hchose > .mobile-column ').slick({
                dots: true,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });





            //  $('.your_wellness_goal .section-content-wrapper').slick({
            //     centerMode: true,
            //     centerPadding: '60px',
            //     dots: false,
            //     arrows: false,
            //     infinite: true,
            //     speed: 300,
            //     slidesToShow: 2,
            //     slidesToScroll: 1,
            //     responsive: [
            //         {
            //             breakpoint: 767,
            //             settings: {
            //                 slidesToShow: 1,
            //                 slidesToScroll: 1
            //             }
            //         }
            //     ]
            // });


        }, 100);
    }


   if (window.innerWidth <= 992) {
     setTimeout(function() {
     $('.flip-box-container ').slick({
                dots: true,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });


            
        }, 100);

   }





          $('.bdg_conbox .layout-panel-flex').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: '<button class="slider-nav prev" id="slick-prev" type="button"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15,18 9,12 15,6"></polyline></svg></button>',
                nextArrow: '<button class="slider-nav next" id="slick-next" type="button"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9,18 15,12 9,6"></polyline></svg></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
            });   
});


// PDF Download
  document.querySelectorAll(".download-pdf-btn").forEach(function(button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      
      const pdfUrl = this.getAttribute('data-pdf-url');
      
      // Use XMLHttpRequest for better binary data handling
      const xhr = new XMLHttpRequest();
      xhr.open('GET', pdfUrl, true);
      xhr.responseType = 'arraybuffer';
      
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = new Blob([xhr.response], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'download.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
      };
      
      xhr.onerror = function() {
        console.error('Download failed');
      };
      
      xhr.send();
    });
  });

document.addEventListener("DOMContentLoaded", function() {
      setTimeout(function() {
         $('.your_wellness_goal .section-content-wrapper').slick({
                centerMode: false,
                centerPadding: '60px',
                dots: true,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 767,
                        centerMode: true,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                     {
                        breakpoint: 992,
                        centerMode: true,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
     }, 100);
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".pb-sciencegrid").forEach((section, sectionIndex) => {
  
    // Find children
    const children = section.querySelectorAll(".group-block");

    // Find load more button (check inside or next sibling)
    let loadMoreBtn = section.querySelector(".pb-loadmore");
    if (!loadMoreBtn && section.nextElementSibling?.classList.contains("pb-loadmore")) {
      loadMoreBtn = section.nextElementSibling;
    } else if (loadMoreBtn) {
      /* .pb-loadmore already lives inside this section */
    } else {
      return;
    }

    let visibleCount = 4;

    // Hide all except first 4
    children.forEach((child, index) => {
      if (index >= visibleCount) {
        child.style.display = "none";
      }
    });

    // Handle load more click
    loadMoreBtn.addEventListener("click", function () {
   
      let shownNow = 0;
      for (let i = visibleCount; i < visibleCount + 4; i++) {
        if (children[i]) {
          children[i].style.display = "block";
          shownNow++;
        }
      }

      visibleCount += shownNow;
      if (visibleCount >= children.length) {
        loadMoreBtn.style.display = "none";
      }
    });
  });

 setTimeout(() => {
document.querySelectorAll(".pb-sciencegrid p").forEach(p => {
    const lineCount = 3;
    const lh = parseFloat(getComputedStyle(p).lineHeight);
    const maxH = lh * lineCount;

    if (p.scrollHeight <= maxH) return;

    p.style.cssText = `overflow:hidden;max-height:${maxH}px;position:relative;transition:max-height .3s ease;`;
    const btn = document.createElement("button");
    btn.textContent = "Read more";
    btn.style.cssText = "border:none;background:none;color:#392E1B;cursor:pointer;display:block; font-weight: 600;padding: 0px;text-decoration: underline;";
    p.after(btn);

    btn.addEventListener("click", () => {
      const expanded = btn.textContent === "Read less";
      p.style.maxHeight = expanded ? `${maxH}px` : `${p.scrollHeight}px`;
      btn.textContent = expanded ? "Read more" : "Read less";
    });
  });
  }, 1000);
});




  // document.addEventListener('DOMContentLoaded', function() {
  //   const addAllBtn = document.getElementById('addAllToCart');
    
  //   if (addAllBtn) {
  //     addAllBtn.addEventListener('click', async function() {
  //       const productItems = document.querySelectorAll('.product-item');
  //       const items = [];
        
  //       // Collect all products with quantities
  //       productItems.forEach(item => {
  //         const variantId = item.querySelector('.quantity-input').dataset.variantId;
  //         const quantity = parseInt(item.querySelector('.quantity-input').value);
          
  //         if (quantity > 0) {
  //           items.push({
  //             id: variantId,
  //             quantity: 1
  //           });
  //         }
  //       });
        
  //       if (items.length === 0) {
  //         alert('Please select at least one product');
  //         return;
  //       }
        
  //       // Disable button during request
  //       addAllBtn.disabled = true;
  //       addAllBtn.textContent = 'Adding...';
        
  //       try {
  //         // Add all items to cart using Shopify AJAX API
  //         const response = await fetch('/cart/add.js', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //           body: JSON.stringify({ items: items })
  //         });
 
  //       if (response.ok) {

  //       const data = await response.json();

  //       // 1️⃣ Fetch FULL PAGE to extract drawer section
  //           fetch(window.location.href)
  //           .then(res => res.text())
  //           .then(fullHtml => {

  //           const parser = new DOMParser();
  //           const doc = parser.parseFromString(fullHtml, "text/html");

  //           const selector = ".cart-drawer, #CartDrawer, [data-cart-drawer]";
  //           const newDrawer = doc.querySelector(selector);
  //           const currentDrawer = document.querySelector(selector);

  //           if (newDrawer && currentDrawer) {
  //               currentDrawer.innerHTML = newDrawer.innerHTML;
  //           } else {
             
  //           }

  //           // Dispatch event
  //           document.documentElement.dispatchEvent(
  //               new CustomEvent("ajaxProduct:added", { bubbles: true })
  //           );

  //           // Open drawer
  //           openDrawer();
  //           });

  //       // 4️⃣ Update cart count (custom theme selector?)

  //       fetch('/cart.js')
  //           .then(res => res.json())
  //           .then(cart => {
  //           // TRY MULTIPLE SELECTORS FROM THE THEME
  //           const selectors = [
  //               ".cart-count",
  //               "[data-cart-count]",
  //               ".cart-bubble",
  //               ".header-cart-count",
  //               ".cart-count-number",
  //               "#cart-count"
  //           ];

  //           selectors.forEach(sel => {
  //               const el = document.querySelector(sel);
  //               if (el) {
  //               el.textContent = cart.item_count;
  //               }
  //           });
  //           });

  //       // 5️⃣ Reset button
  //       addAllBtn.disabled = false;
  //       addAllBtn.textContent = 'Add to Cart';
  //       }


  //       /* ------------------------------
  //       ⭐ Drawer Opening Function
  //       ------------------------------*/
  //       function openDrawer() {
  //       const customDrawer = document.querySelector("cart-drawer");
  //       if (customDrawer && typeof customDrawer.open === "function") {
  //           customDrawer.open();
  //           return;
  //       }
  //           setTimeout(function() {
          
  //                const cartDrawer = document.querySelector("cart-drawer, .cart-drawer, #cart-drawer");

  //                 if (cartDrawer && typeof cartDrawer.open === "function") {
  //                   cartDrawer.open();
  //                 } else {
  //                   document.documentElement.classList.add("cart-open");
  //                 }
               
  //           }, 800);

  //           }

  //       } catch (error) {
  //         console.error('Error:', error);
                    
  //         // Reset button
  //         addAllBtn.disabled = false;
  //         addAllBtn.textContent = 'Add to Cart';
  //       }
  //     });
  //   }
  //  });


  document.addEventListener('DOMContentLoaded', function () {

  // Select ALL buttons that start with addAllToCart-
  const addAllButtons = document.querySelectorAll('[id^="addAllToCart-"]');

  addAllButtons.forEach(addAllBtn => {

    addAllBtn.addEventListener('click', async function () {

      // Find the closest section (parent wrapper)
      const section = addAllBtn.closest('section, .shopify-section, .product-bundle-section');

      if (!section) return;

      const productItems = section.querySelectorAll('.product-item');
      const items = [];

      productItems.forEach(item => {
        const input = item.querySelector('.quantity-input');
        const variantId = input.dataset.variantId;
        const quantity = parseInt(input.value);

        if (quantity > 0) {
          items.push({
            id: variantId,
            quantity: quantity
          });
        }
      });

      if (items.length === 0) {
        alert("Please select at least one product");
        return;
      }

      // Disable button during request
       var activebtncnt =  addAllBtn.textContent;
      addAllBtn.disabled = true;
      addAllBtn.textContent = "Adding…";

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
        });

        if (response.ok) {

          // Update drawer
          fetch(window.location.href)
            .then(res => res.text())
            .then(fullHtml => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(fullHtml, "text/html");

              const selector = ".cart-drawer, #CartDrawer, [data-cart-drawer]";
              const newDrawer = doc.querySelector(selector);
              const currentDrawer = document.querySelector(selector);

              if (newDrawer && currentDrawer) {
                currentDrawer.innerHTML = newDrawer.innerHTML;
              }

              document.documentElement.dispatchEvent(
                new CustomEvent("ajaxProduct:added", { bubbles: true })
              );

              openDrawer();
            });

          // Update cart count
          fetch("/cart.js")
            .then(res => res.json())
            .then(cart => {
              const selectors = [
                ".cart-count",
                "[data-cart-count]",
                ".cart-bubble",
                ".header-cart-count",
                ".cart-count-number",
                "#cart-count"
              ];
              selectors.forEach(sel => {
                const el = document.querySelector(sel);
                if (el) el.textContent = cart.item_count;
              });
            });

        } else {
          // A failed add - sold out, 4xx, 5xx - must never leave a dead control.
          let message = "Sorry, we could not add that to your cart. Please try again.";
          try {
            const err = await response.json();
            if (err && err.description) message = err.description;
          } catch (parseError) {}
          alert(message);
        }

        function openDrawer() {
          const customDrawer = document.querySelector("cart-drawer");
          if (customDrawer && typeof customDrawer.open === "function") {
            customDrawer.open();
            return;
          }

          setTimeout(() => {
            const cartDrawer = document.querySelector(
              "cart-drawer, .cart-drawer, #cart-drawer"
            );
            if (cartDrawer && typeof cartDrawer.open === "function") {
              cartDrawer.open();
            } else {
              document.documentElement.classList.add("cart-open");
            }
          }, 600);
        }

      } catch (error) {
        console.error(error);
        alert("Sorry, we could not add that to your cart. Please try again.");
      } finally {
        // Every outcome - success, HTTP error, network error - restores the button.
        addAllBtn.disabled = false;
        addAllBtn.textContent = activebtncnt;
      }
    });
  });
});




// $('.flip-button').on('click',function(){
// alert("Hiii");
//     $(this).closest('.flip-box').addClass('is-flipped');
// });

$(document).on('click', '.flip-button', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $('.flip-box').removeClass('is-flipped');
    $(this).closest('.flip-box').addClass('is-flipped');
});




document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.slideshow-controls__thumbnails');
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // scroll speed
    slider.scrollLeft = scrollLeft - walk;
  });
});



(function () {

  const footerMQ = window.matchMedia("(max-width: 768px)");
  const footerItems = [];
  let footerUid = 0;

  function setFooterOpen(item, open) {
    item.ul.style.display = open ? "block" : "none";
    item.btn.setAttribute("aria-expanded", open ? "true" : "false");
    item.wrapper.classList.toggle("open", open); // 🔼🔽 icon toggle
  }

  function initFooterAccordion() {
    let wired = 0;
    document.querySelectorAll(".collapse_footer h4").forEach(h4 => {

      const wrapper = h4.closest(".collapse_footer");
      const accordion = h4.closest(".group-block-content")
        ?.querySelector("accordion-custom");

      if (!accordion) return;

      const ul = accordion.querySelector("ul");
      if (!ul) return;
      if (h4.dataset.vyFooterAcc === "1") return;

      // WCAG 2.1.1: the control has to be a real button so it is reachable by
      // keyboard and Enter AND Space activate it natively. The heading text moves
      // inside the button, so the <h4> keeps its heading semantics.
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "collapse_footer__toggle";
      btn.style.cssText = "display:block;width:100%;margin:0;padding:0;border:0;background:none;font:inherit;color:inherit;letter-spacing:inherit;text-transform:inherit;text-align:inherit;line-height:inherit;cursor:pointer;";
      while (h4.firstChild) btn.appendChild(h4.firstChild);
      h4.appendChild(btn);

      if (!ul.id) ul.id = "vy-footer-panel-" + (++footerUid);
      btn.setAttribute("aria-controls", ul.id);
      h4.dataset.vyFooterAcc = "1";

      const item = { wrapper: wrapper, btn: btn, ul: ul };
      footerItems.push(item);
      wired++;

      btn.addEventListener("click", function () {
        if (!footerMQ.matches) return; // desktop: the list is always shown
        setFooterOpen(item, window.getComputedStyle(ul).display === "none");
      });
    });

    syncFooterAccordion();
    return wired;
  }

  function syncFooterAccordion() {
    footerItems.forEach(function (item) {
      if (footerMQ.matches) {
        setFooterOpen(item, false);
      } else {
        // Desktop: never leave the menu collapsed by a stale inline style.
        item.ul.style.display = "";
        item.btn.removeAttribute("aria-expanded");
        item.wrapper.classList.remove("open");
      }
    });
  }

  let footerWasMobile = footerMQ.matches;

  function onFooterViewportChange() {
    const isMobile = footerMQ.matches;
    if (isMobile === footerWasMobile) return; // only act on a real breakpoint flip
    footerWasMobile = isMobile;
    syncFooterAccordion();
  }

  function startFooterAccordion() {
    // The footer can still be injected after this point, and
    // initFooterAccordion() is idempotent (guarded by data-vy-footer-acc),
    // so retry briefly and stop as soon as it wires something.
    initFooterAccordion();
    window.addEventListener("load", initFooterAccordion);
    let footerTries = 0;
    const footerPoll = setInterval(function () {
      if (initFooterAccordion() > 0 || ++footerTries > 20) clearInterval(footerPoll);
    }, 250);

    if (footerMQ.addEventListener) {
      footerMQ.addEventListener("change", onFooterViewportChange);
    } else if (footerMQ.addListener) {
      footerMQ.addListener(onFooterViewportChange);
    }
    // matchMedia "change" does not fire in every environment, so also watch resize.
    // Both funnel through onFooterViewportChange, which acts only when the breakpoint
    // actually flips - so a mobile URL-bar resize never closes an open menu.
    let footerResizeTick = false;
    window.addEventListener("resize", function () {
      if (footerResizeTick) return;
      footerResizeTick = true;
      requestAnimationFrame(function () {
        footerResizeTick = false;
        onFooterViewportChange();
      });
    }, { passive: true });
  }

  // custom.js is loaded async, so DOMContentLoaded has usually ALREADY fired by the
  // time this file runs - waiting on that event would never start the accordion.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startFooterAccordion);
  } else {
    startFooterAccordion();
  }

})();


